import { AvatarProps } from "@radix-ui/react-avatar"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils";
import { VipPlusIcon } from "./fun-ui/icons";
import { useUser, useUserVip } from "@/stores/appStore";


export function UserAvatar({ size = 'lg', ...props }: {
  size: 'sm' | 'lg';
} & AvatarProps) {
  const {
    vip
  } = useUserVip();
  const { user } = useUser();
  if (!user) {
    return <></>
  }
  return (
    <div className="w-fit h-fit relative">
      <Avatar
        className={cn(
          size === 'sm' && "h-7 w-7 border-[1.5px] border-solid",
          size === 'lg' && "h-32 w-32 border-4",
          vip === 1 ? "border-[#987E61]" : "border-transparent",
        )}
        {...props}
      >
        {user?.avatar ? (
          <AvatarImage alt="Picture" src={user.avatar} />
        ) : (
          <AvatarFallback>
            <span className="sr-only">{user?.nickname}</span>
          </AvatarFallback>
        )}
      </Avatar>
      {
        vip === 1 ? (
          <VipPlusIcon
            className="absolute w-fit h-auto"
            style={
              size === 'lg' ? {
                right: '-10%',
                bottom: 0,
              } : {
                right: '-38%',
                bottom: '-8%'
              }
            }
            width={
              size === 'sm' ? 28 : 74
            }
            height={
              size === 'sm' ? Math.round(28 / 2.375) : Math.round(74 / 2.375)
            }
          />
        ) : null
      }
    </div>
  )
}
